import { render, staticRenderFns } from "./TermsAndConditionsLayout.vue?vue&type=template&id=2c0de098&scoped=true&"
import script from "./TermsAndConditionsLayout.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsLayout.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsLayout.vue?vue&type=style&index=0&id=2c0de098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0de098",
  null
  
)

export default component.exports